import script from "./CreateUpdateTypesService.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUpdateTypesService.vue?vue&type=script&setup=true&lang=js"

import "./CreateUpdateTypesService.vue?vue&type=style&index=0&id=0f1fd2d8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1fd2d8"]])

export default __exports__